import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Col } from 'react-bootstrap';
import { isEqual } from 'lodash';
import classNames from 'classnames';
import { Loader } from '@components/common';

import { settingsMenuSections as SECTIONS } from '@config';
import { thunks } from '@redux/app';
import SettingsMenu from './components/settingsMenu';
import PersonalSettings from './components/personalSettings';
import ProfileSettings from './components/profileSettings';
import ChangePassword from './components/changePassword';
import CompanyBio from './components/companyBio';
import PaymentMethods from './components/paymentMethods';
import NotificationSettings from './components/notificationSettings';
import TaxExempt from './components/taxExempt';

class Account extends Component {
	constructor(props) {
		super(props);

		this.state = { sectionInView : SECTIONS[0].id };

		this.windowScrollEventHandler = this.handleWindowScroll;
	}

	componentDidMount() {
		const { getUser } = this.props;
		getUser();

		window.onscroll = this.handleWindowScroll;
		const { location : { hash } } = this.props;

		if (hash) {
			const id = hash.replace('#', '');
			const newSectionInView = SECTIONS.find((section) => id === section.id);

			if (newSectionInView.id) {
				this.scrollTo(newSectionInView.id);
			}
		}
	}

	shouldComponentUpdate = ({ Organization, loading }, { sectionInView }) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(lastProps.Organization, Organization)
			|| !isEqual(lastProps.loading, loading)
			|| !isEqual(lastState.sectionInView, sectionInView)
		);
	}

	componentWillUnmount = () => {
		window.onscroll = null;
	}

	handleWindowScroll = () => {
		const { sectionInView } = this.state;
		const pageOffset = window.pageYOffset;
		const newSectionInView = SECTIONS.find((section) => pageOffset < (this[section.id].offsetTop + (this[section.id].offsetHeight / 2)));
		if (newSectionInView && sectionInView !== newSectionInView.id) this.setState({ sectionInView : newSectionInView.id });
	}

	scrollTo = (section) => {
		const top = this[section].offsetTop;
		window.scroll({ top, behavior : 'smooth' });
	}

	setRef = (section) => (ref) => {
		this[section] = ref;
	}

	render() {
		const { sectionInView } = this.state;
		const {
			Organization, loading, IsStaffAdmin,
		} = this.props;
		return (
			<Grid className="settings-container">
				<Col md={12}>
					<h3 className="color-dark">Account Settings</h3>
					<span className={classNames('color-gray-regent', { hidden : !Organization.Name })}>
						<i className="rkfm rkfm-briefcase margin-right-5" />
						{ Organization.Name }
					</span>
				</Col>
				<Col
					md={8}
					xs={12}
					className="margin-top-10"
				>
					<PersonalSettings setRef={this.setRef('personal')} />
					<ProfileSettings setRef={this.setRef('profile')} />
					<ChangePassword setRef={this.setRef('password')} />
					<If condition={IsStaffAdmin}>
						<CompanyBio setRef={this.setRef('bio')} />
					</If>
					<PaymentMethods setRef={this.setRef('payment')} />
					<NotificationSettings setRef={this.setRef('notification')} />
					<If condition={IsStaffAdmin}>
						<TaxExempt setRef={this.setRef('tax-exempt')} />
					</If>
				</Col>
				<Col
					md={4}
					xs={12}
					className="margin-top-20"
				>
					<SettingsMenu
						scrollTo={this.scrollTo}
						sectionInView={sectionInView}
						isStaffAdmin={IsStaffAdmin}
					/>
				</Col>
				<Loader active={loading} />
			</Grid>
		);
	}
}

const mapStateToProps = ({
	app : {
		user : { Organization = {}, IsStaffAdmin },
		loading,
	},
}) => ({
	Organization,
	IsStaffAdmin,
	loading,
});

Account.propTypes = {
	IsStaffAdmin : PropTypes.bool,
	Organization : PropTypes.object,
	loading      : PropTypes.bool,
	location     : PropTypes.object.isRequired,
	getUser      : PropTypes.func.isRequired,
};

Account.defaultProps = {
	IsStaffAdmin : false,
	Organization : {},
	loading      : false,
};

const mapDispatchToProps = (dispatch) => ({
	getUser : bindActionCreators(thunks, dispatch).getUser,
});

export default connect(mapStateToProps, mapDispatchToProps)(Account);
